module.exports = __webpack_public_path__ + "img/天力文化衫.ea887b67.jpg";